// @need-translate
import merge from 'lodash/merge';
import {UrlLink} from '../../../applink/UrlLink';
import {tt} from '../../../common/getTranslations';
import {LogTabType} from '../../../common/LogTabType.enum';
import {twMerge} from '../../../common/twMerge';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {PageViewCustomPropsDataKey} from '../../../logging/PageViewCustomPropsDataKey.enum';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {Text} from '../../atoms/Text/Text';
import {ArrowDirection} from '../../molecules/Tooltip/ArrowDirection.enum';
import {Tooltip} from '../../molecules/Tooltip/Tooltip';
import {HeaderTitle} from '../HeaderTitle/HeaderTitle';
import {PcMainTabItem} from '../PcMainTabItem/PcMainTabItem';
import {MainTabProps} from './MainTabProps.interface';

export function PcMainTab({
  title,
  titleClassName,
  tabItems,
  currentTabItemId,
  logTabType,
  gnbTitle,
  isSubtabPage,
  useCustomClickEvent,
  onClickTab,
  actionName,
  tabItemTiaraObject,
  selectBoxText,
  onClickSelectBox,
  className,
  ...props
}: Omit<MainTabProps, 'isMobile'>) {
  if (!tabItems) {
    return null;
  }

  return (
    <div
      className={twMerge(
        'relative mt-20pxr mb-32pxr flex w-full flex-col bg-transparent',
        className
      )}
      {...props}
    >
      {title && <HeaderTitle className={titleClassName}>{title}</HeaderTitle>}
      <div className="flex h-full w-full justify-between">
        <div className="flex h-full w-full flex-row space-x-8pxr">
          {tabItems.map((tabItem, index) => {
            const isSelected = currentTabItemId === tabItem.id;
            return (
              <div
                className="relative flex items-center justify-center"
                key={tabItem.id}
              >
                <UrlLink
                  url={tabItem.href}
                  shouldOpenNewTab={tabItem.shouldOpenNewTab}
                >
                  <PcMainTabItem
                    className="z-10"
                    isActive={isSelected}
                    hasDot={tabItem.hasDot}
                    onClick={e => {
                      if (useCustomClickEvent) {
                        onClickTab && onClickTab(tabItem.id, e);
                      } else {
                        LOG_CLICK_EVENT(
                          actionName
                            ? actionName
                            : isSubtabPage
                              ? `${gnbTitle ?? tabItem.text}_서브탭_클릭`
                              : `${gnbTitle ? `${gnbTitle}_` : ''}서브탭_클릭`,
                          e,
                          () => onClickTab && onClickTab(tabItem.id)
                        );
                      }
                    }}
                    {...{
                      [PageViewCustomPropsDataKey.PageCategoryFilter]:
                        isSelected && logTabType === LogTabType.Category
                          ? `page_category_filter=${tabItem.text}`
                          : undefined,
                      [PageViewCustomPropsDataKey.PageGenreFilter]:
                        isSelected && logTabType === LogTabType.Genre
                          ? `page_genre_filter=${tabItem.text}`
                          : undefined,
                    }}
                    {...putTiaraObjectProps(
                      !useCustomClickEvent
                        ? merge(
                            {
                              click: {
                                layer1: '서브탭',
                                copy: tabItem.text,
                                ordnum: String(index + 1),
                              },
                            },
                            tabItemTiaraObject
                          )
                        : undefined
                    )}
                  >
                    {isSelected && <Text className="blind">선택됨, </Text>}
                    {tt(tabItem)}
                    <Text className="blind">
                      탭, {`총 ${tabItems.length}개 중 ${index + 1}번째`}
                    </Text>
                  </PcMainTabItem>
                </UrlLink>
                {tabItem.hasTooltip && tabItem.tooltipMessage && (
                  <div className="absolute top-full">
                    <Tooltip
                      arrowDirection={ArrowDirection.Top}
                      text={tabItem.tooltipMessage}
                      showTooltip={true}
                      onClickTooltipCancel={tabItem.onClickCloseTooltip}
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {selectBoxText && (
          <div
            className="flex shrink-0 cursor-pointer select-none items-center justify-center"
            onClick={onClickSelectBox}
          >
            <Text className="font-small2 text-theme-solid-100">
              {selectBoxText}
            </Text>
            <Icon type={IconType.TabArrowDown} disableActiveEffect />
          </div>
        )}
      </div>
    </div>
  );
}
